import {NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';

export default class TimeTrackerUtils {

  static obtainDateFromDateAndNgbTimeStruct(date: Date, timeModel: NgbTimeStruct): Date {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), timeModel.hour, timeModel.minute));
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/time-tracker/time-tracker-utils.ts